import { Grid } from '@mui/material';
import { CreateInvoiceArticleRows } from 'src/modules/invoice/components/createInvoiceArticleRows';
import ControlledDatePicker from 'src/shared/components/form/controlledDatePicker';
import ControlledSelectBox from 'src/shared/components/form/controlledSelectBox';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import { createInvoiceMissionTypes } from './memberCreateInvoiceModalForMemberFee';

export const MemberCreateInvoiceArticleForm = () => {
  const { t } = useTranslation(['invoice']);
  return (
    <>
      <Grid item xs={4}>
        <ControlledDatePicker name='dueDate' label={t('invoice:createInvoice.dueDate')} />
      </Grid>
      <Grid item xs={8}>
        <ControlledSelectBox
          name='invoiceMission_id'
          label={t('invoice:createInvoice.invoiceMissionType')}
          items={createInvoiceMissionTypes.map((item) => {
            return { ...item, label: t(item.label) };
          })}
        />
      </Grid>
      <Grid item xs={12}>
        <CreateInvoiceArticleRows />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='heading' label={t('invoice:createInvoice.invoiceRow.heading')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField multiline name='subHeading' label={t('invoice:createInvoice.invoiceMessageHeader')} rows={8} />
      </Grid>
    </>
  );
};
